<template>
  <div class="attributes-checkbox">
    <ul>
      <li v-for="attr in filter.values" :class="{'selected': isSelected(filter.name, attr)}" @click="select(filter.name, attr)" >
        <input type="checkbox" :checked="isSelected(filter.name, attr)" />
        <span >{{attr}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    props: ['filter'],
    computed: {
      ...mapState({
        search: state => state.search,
      }),
    },
    methods: {
      isSelected(name, value ) {
        let attribute = this.search.attributes.find(a => a.name == name);
        if (attribute) {
          let index = attribute.values.indexOf(value);
          return index >= 0;
        }
        return false;
      },
      select(name, value ) {
        let attribute = this.search.attributes.find(a => a.name == name);
        if (!attribute) {
          attribute = {name: name, values: []}
          this.search.attributes.push(attribute);
        }
        let index = attribute.values.indexOf(value);
        if (index > -1) {
          attribute.values.splice(index, 1);
        } else {
          attribute.values.push(value);
        }
        this.$store.dispatch('search/reload');
      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/layout/src/input/AttributesCheckBox.vue